import DiscoverMemberships from './DiscoverMemberships'

export default DiscoverMemberships
